import { IDeleteSubcontasUseCase } from "../../../presentation/useCases/delete/delete_subcontas_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * DeleteSubcontasUseCase
 */

export class DeleteSubcontasUseCase implements IDeleteSubcontasUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(idSubconta: number): Promise<void> {
    await this.repository.deleteSubcontaById(idSubconta);

  }
}
